import React from 'react';
import { Icon } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';

import './infos-dimmer.scss';

import TechnicalsInfos from './TechnicalsInfos';
import CustomMap from '../../../../../Reusable/Map';

const InfosDimmer = ({photo, handleClick}) => {
  if (!photo) {
    return null;
  }

  return (
    <div className="dimmer-container-infos">
      <Icon onClick={handleClick} name='close' className="fixed-icon-close" />
      <div className="left">
        <div className="infos">
          <div className="title">{photo.title}</div>
          <div className="place"><Icon name='map signs' /> {photo.place}</div>
          <div className="caption">
            <ReactMarkdown source={photo.caption} />
          </div>
        </div>
        <div className="infos-techniques">
          <TechnicalsInfos data={photo}/>
        </div>
      </div>
      <div className="right">
        <div className="map">
          <CustomMap zoom={14} usage={"one"} id={photo.id}/>
        </div>
      </div>
    </div>
  );
};

export default InfosDimmer;
